import React from 'react';
import { Link } from 'react-router-dom';

import { HOME } from '../../constants';
import { FOOTER_LINK_FAMILIES } from './constants';
import FooterLinkFamily from './FooterLinkFamily/FooterLinkFamily';

import sharedStyles from '../../styles/_sharedStyles.module.scss';
import componentStyles from './Footer.module.scss';

const Footer = () => {
  const footerLinkFamilyList = FOOTER_LINK_FAMILIES.map((footerLinkFamily) => (
    <FooterLinkFamily
      key={footerLinkFamily.label}
      label={footerLinkFamily.label}
      links={footerLinkFamily.links}
    />
  ));

  return (
    <div className={`${componentStyles.footer} ${sharedStyles['content--lg']}`}>
      <div className="row">
        <div className="col-md-5">
          <Link to={HOME} className="logo">
            funeralApp
          </Link>

          <p className={componentStyles['footer-made-in']}>Made with ❤️ in NYC.</p>
        </div>

        <div className="col-md-7">
          <div className="row">{footerLinkFamilyList}</div>
        </div>
      </div>
    </div>
  );
};

export default Footer;
